module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/two-bottles-a82371e9afa57dfdf110882625bafee0.svg";